// src/components/CalculatorCard.ts
import "./CalculatorCard.css";

export function renderCalculatorCard(
  container: HTMLElement,
  query: string,
): void {
  let result = "Error";

  try {
    // Safe eval: only numbers and math symbols allowed
    if (/^[0-9+\-*/(). ]+$/.test(query)) {
      // eslint-disable-next-line no-eval
      result = eval(query).toString();
    }
  } catch {}

  container.innerHTML = `
    <div class="card-container calc-card">
      <div class="calc-expression">${query}</div>
      <div class="calc-result">${result}</div>
    </div>
  `;
}
